import { render, staticRenderFns } from "./ServicesFinancialOverview.vue?vue&type=template&id=f36206d6&scoped=true&"
import script from "./ServicesFinancialOverview.vue?vue&type=script&lang=js&"
export * from "./ServicesFinancialOverview.vue?vue&type=script&lang=js&"
import style0 from "./ServicesFinancialOverview.vue?vue&type=style&index=0&id=f36206d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36206d6",
  null
  
)

export default component.exports